export default "__VITE_ASSET__DihI7ig9__"